import Axios from 'axios'
import store from '../store'

const settings = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getInitialSettings (clientId) {
    let requestClient = this.getClientId()
    if(clientId){
      requestClient = clientId
    }
    return Axios.get(`api/v1/clients/${requestClient}/configurations`)
  }
}
export default settings
